var render = function render(){var _vm=this,_c=_vm._self._c;return _c('peekai-nudge-banner',{attrs:{"step":_vm.step,"progress-step":_vm.progressStep,"disabled":_vm.busy},on:{"confirm":_vm.onConfirm,"view-report":_vm.onViewReport}})
}
var staticRenderFns = []

export { render, staticRenderFns }